import store from '@/store';
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';

export interface UserState {
  /** userName */
  userName: string;
}

/**
 * 認証関連の状態管理クラス
 * このクラスの状態はリロードしても状態が保持される
 */
@Module({
  name: 'user',
  namespaced: true,
  dynamic: true,
  store,
  // ↓リロードしても状態を保持する場合に、この1行で追加制御が必要
  preserveState: sessionStorage.getItem('zion-ui') !== null
})
export class User extends VuexModule implements UserState {
  userName = '';
  userEmail = '';

  /**
   * userNameを設定する
   *
   * @param userName HexabaseのuserName
   */
  @Mutation
  setUserName(userName: string) {
    this.userName = userName;
  }

  /**
   * userEmailを設定する
   *
   * @param userEmail HexabaseのuserEmail
   */
  @Mutation
  setUserEmail(userEmail: string) {
    this.userEmail = userEmail;
  }

  /**
   * UserStateをリセットする
   */
  @Mutation
  clearUserState() {
    this.userName = '';
    this.userEmail = '';
  }

  /**
   * userNameを取得する
   *
   * @returns userName
   */
  public get getUserName(): string {
    return this.userName;
  }

  /**
   * userEmailを取得する
   *
   * @returns userName
   */
  public get getUserEmail(): string {
    return this.userEmail;
  }
}

export default getModule(User);
